export const events = [
  {
    id: 1,
    name: 'Netaş & Microsoft Teknoloji Buluşması',
    date: '2025-01-11',
    location: 'Sapanca, Türkiye',
    title: 'Windows Autopilot ve Azure Arc Çözümleri',
    description: 'İlham veren sunumlar, güçlü iş birlikleri ve teknoloji dolu iki günün ardından Sapanca\'da gerçekleştirdiğimiz Netaş & Microsoft Teknoloji Buluşmasını keyifle tamamladık! Microsoft\'un Windows Autopilot ve Azure Arc çözümlerini Microsoft Çözüm Ekibi yöneticimiz Özgür Çebi ve Microsoft Azure ekibimizden Ömür Değer\'in anlatımlarıyla detaylı olarak konuştuk.',
    attendees: 120,
    rating: 4.9,
    topics: ['Windows Autopilot', 'Azure Arc', 'Dijital Dönüşüm', 'Bulut Bilişim', 'Microsoft'],
    slidesUrl: '#',
    videoUrl: '#',
    imageUrl: 'https://media.licdn.com/dms/image/v2/D4D22AQEi_PHHoU5n7w/feedshare-shrink_2048_1536/B4DZdeG_lUGYAs-/0/1749630582450?e=2147483647&v=beta&t=WNpFuj3twKan2t0DBbUKAcvRSwo7M7fLBnV09MhSjkA',
    linkedInUrl: 'https://www.linkedin.com/posts/netastr_netaagn-microsoft-dijitaldaemnaesagnaesm-activity-7338482556893302784-r1Q8',
  },
  {
    id: 2,
    name: 'Netaş | Microsoft Teknoloji Buluşması #2',
    date: '2024-05-31',
    location: 'Türkiye',
    title: 'Yapay Zeka, Güvenlik ve Microsoft Fabric',
    description: 'Bir Microsoft CSI (Cyber Security Investment) Partner\'ı olarak 30-31 Mayıs tarihlerinde Netaş | Microsoft Teknoloji Buluşması etkinliğimizin ikincisini gerçekleştirdik. Değerli katılımcılarımız yapay zeka ve güvenlik alanındaki teknolojileri Microsoft ve Netaş uzmanlarından dinleme imkanı buldu. Azure üzerindeki uygulamaların güvenlik stratejilerinden bahsettiğimiz etkinliğimizde ayrıca yapay zeka destekli veri analiz platformu olan Microsoft Fabric ile verilerin yorumlanması ve içgörüler oluşturmanın firmalara katacağı faydaları da aktarma imkanı bulduk. Bize heyecan veren bir yenilik olarak; Teams sohbeti yedekleme ve arşivleme ürünümüz TeamsVault\'u müşterilerimize tanıttık.',
    attendees: 150,
    rating: 4.8,
    topics: ['Microsoft Security', 'TeamsVault', 'Yapay Zeka', 'Güvenlik', 'Microsoft 365 Copilot', 'Copilot for Security'],
    slidesUrl: '#',
    videoUrl: '#',
    imageUrl: 'https://media.licdn.com/dms/image/v2/D4D10AQGjtFl8-b4Cbw/image-shrink_1280/image-shrink_1280/0/1718585005374?e=2147483647&v=beta&t=GWMiysZRKizipprdT059dB4figYmszyKnuvE1gQijeI',
    linkedInUrl: 'https://www.linkedin.com/posts/netastr_microsoftfabric-teamsvault-netaagn-ugcPost-7203356692397359104-D0B6',
  },
  {
    id: 3,
    name: 'Microsoft Partner of the Year 2024',
    date: '2024-11-22',
    location: 'Amerika Birleşik Devletleri',
    title: 'Microsoft Partner of the Year Ödül Töreni',
    description: '2024 yılı Microsoft Partner of the Year ödülüne layık görülmenin gururunu bir kez daha yaşıyoruz. Bu önemli başarıyı Amerika\'daki Microsoft etkinliğinde fiziksel olarak teslim alarak taçlandırdık. Bu ödül, teknoloji alanındaki yenilikçi yaklaşımımız ve iş ortaklarımızla kurduğumuz güçlü bağların bir göstergesi. Global bir platformda takdir edilmek, yalnızca bir gurur kaynağı değil, aynı zamanda sorumluluğumuzu artıran bir motivasyon.',
    attendees: 250,
    rating: 5.0,
    topics: ['Partner of the Year', 'Microsoft', 'Teknoloji', 'İnovasyon', 'Dijital Dönüşüm'],
    slidesUrl: '#',
    videoUrl: '#',
    imageUrl: 'https://media.licdn.com/dms/image/v2/D4D10AQGHsYvi68vMuQ/image-shrink_1280/image-shrink_1280/0/1732285610469?e=2147483647&v=beta&t=21aFhYlTpvbPsofWhoD0ozg6qMFdjrlKQAuJtZAwnBA',
    linkedInUrl: 'https://www.linkedin.com/posts/netastr_netaagn-microsoft-partneroftheyear-activity-7265732466726895617-PDp1',
  },
  {
    id: 4,
    name: 'Netaş | Microsoft Teknoloji Buluşması #1',
    date: '2023-12-15',
    location: 'Türkiye',
    title: 'Güvenlik, Yapay Zeka ve Dijital Dönüşüm',
    description: 'Microsoft CSI (Cyber Security Investment) Partner\'ı olarak 14-15 Aralık tarihlerinde gerçekleştirdiğimiz Netaş | Microsoft Teknoloji Buluşması etkinliğimizi, güvenlik ve yapay zeka çerçevesinde bir araya geldiğimiz oturumlar ve değerli müşterimiz Brisa ile paylaştığımız Brisa\'nın güvenlik dönüşümü sohbetiyle dolu dolu geçirdik. Katılımcılarımızı güvenlik alanındaki en son trendler, Netaş\'ın Microsoft güvenlik çözümlerindeki tecrübeleri ve yapay zekanın iş dünyasında yarattığı dönüşüm konu başlıkları alanında uzman isimlerle buluşturduk. Aynı zamanda müşterilerimize Microsoft 365 Copilot, Microsoft XDR, Microsoft Purview ürünleri ve iş süreçlerindeki verimliliği artırmanın yollarını da aktardık.',
    attendees: 130,
    rating: 4.8,
    topics: ['Microsoft Security', 'Microsoft 365 Copilot', 'Microsoft XDR', 'Microsoft Purview', 'Yapay Zeka', 'Dijital Dönüşüm'],
    slidesUrl: '#',
    videoUrl: '#',
    imageUrl: 'https://media.licdn.com/dms/image/v2/D4D22AQF7-6T2Gv5TlQ/feedshare-shrink_2048_1536/feedshare-shrink_2048_1536/0/1703062205237?e=2147483647&v=beta&t=rmlbcysANB5BB55qWiJDUIrmyuq3VZPnwqYLqUXX4hA',
    linkedInUrl: 'https://www.linkedin.com/posts/netastr_netaagn-microsoft-brisa-activity-7143160624745811968-ljqJ',
  },
];
